export const ERR_AUTH_NOT_MEMBER = "LOGIN_INVALID_ACCOUNT";